module.exports = __webpack_public_path__ + "images/xp-coins.jpg";